// The one list the V2 side menu is made from: add a page here and it shows in the menu. `path` is under /v2.
export const navSections = [
  {
    label: 'Devices',
    items: [
      { label: 'Devices', path: '/v2/devices', icon: '▣' },
      { label: 'Patching', path: '/v2/patching', icon: '⛨' },
    ],
  },
  {
    label: 'Software',
    items: [
      { label: 'Policy', path: '/v2/software/policy', icon: '☰' },
      { label: 'Drift', path: '/v2/software/drift', icon: '⇅' },
      { label: 'Vulnerabilities (CVE)', path: '/v2/software/cve', icon: '⚠' },
    ],
  },
  {
    label: 'Global',
    items: [
      { label: 'Policy', path: '/v2/global/policy', icon: '☷' },
    ],
  },
];

export const pageTitle = (pathname) => {
  const found = navSections.flatMap((s) => s.items).find((i) => pathname === i.path || pathname.startsWith(`${i.path}/`));
  return found ? found.label : 'Devices';
};
